import { Link, useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import AuthController from "@controllers/auth.controller";
import AuthLayout from "@components/layout/AuthLayout";
import FormInput from "@components/layout/FormInput";
import Button from "@components/ui/Button";
import State, {STATE, InvitationState, LoginFlowState} from "@state";
import { useSession, clearSession } from "@hooks/useSession";
import NavigationService from "@/network/services/navigation.service";
import InvitationController from "@/network/controllers/invitation.controller"

export default function Invitation() {
  const navigate = useNavigate();
  const location = useLocation();
  const { session, user } = useSession();

  const [errors, setErrors] = useState()
  const [invitationParams, setInvitationParams] = useState({
    invitationId: null,
    authId: null,
    type: null,
    studyId: null,
  })
  const [isLoadingInvitation, setIsLoadingInvitation] = useState(true)

  useEffect(() => {

    clearSession();
    State.reset();

    console.log('=== location.search === Invitation.jsx === key: 962621 ===');
    console.dir(location.search, { depth: null, colors: true })
    console.log('=================================');

    const queryParams = new URLSearchParams(location.search)
    const invitationId = queryParams.get("invitationId")
    const authId = queryParams.get("authId")
    const typeFromUrl = queryParams.get("type")
    const studyIdFromUrl = queryParams.get("studyId") 

    setInvitationParams({ invitationId, authId, type: typeFromUrl, studyId:studyIdFromUrl })

    const fetchInvitationDetails = async () => {
      console.log('=== "fetchInvitationDetails" === Invitation.jsx === key: 294404 ===');
      console.dir("fetchInvitationDetails", { depth: null, colors: true })
      console.dir(typeFromUrl, { depth: null, colors: true })
      console.log('=================================');
      if (invitationId && authId) {
        try {
          let filter = ["pending","joined"]
          if (typeFromUrl === "participant") {
            filter = ["pending","joined"]
          }
          if (typeFromUrl === "investigator") {
            filter = ["pending","joined"]
          }
          if (typeFromUrl === "cro") {
            filter = ["pending","joined"]
          }
          if (typeFromUrl === "join_cro") {
            filter = ["pending","joined"]
          }
          if (typeFromUrl === "participant") {
            filter = ["pending"]
          }

          console.log('=== filter === Invitation.jsx === key: 600115 ===');
          console.dir(filter, { depth: null, colors: true })
          console.log('=================================');

          const response = await InvitationController.getInvitationDetails(invitationId, authId, filter)
          console.log("Invitation Data:")
          console.log('=== response.data === UserSignup.jsx === key: 631049 ===');
          console.dir(response.data, { depth: null, colors: true })
          console.log('=================================');

          if (response.success && response.data) {
           
            const {
              email,
              firstname,
              lastname,
              site_name,
              site_id,
              invitation_type,
              entity_id,
              phone_number,
              postal_address_1,
              postal_address_2,
              country,
              city,
              zipcode,
              investigator_id,
              investigator_firstname,
              investigator_lastname,
              assigned_company_name, 
              study_id: fetched_study_id, 
              delegate,
            } = response.data

            

         

            let mappedInvitationType = invitation_type
            switch (invitation_type) {
              case "cro":
                mappedInvitationType = InvitationState.INVITATION_TYPE_NEW_CRO
                break
              case "join_cro":
                mappedInvitationType = InvitationState.INVITATION_TYPE_JOIN_CRO 
                break
              case "investigator":
                mappedInvitationType = InvitationState.INVITATION_TYPE_JOIN_STUDY_INVESTIGATOR
                break
              case "participant": 
                mappedInvitationType = InvitationState.INVITATION_TYPE_JOIN_STUDY_PATIENT
                break
              default:
                console.warn(`Unknown invitation_type from backend: ${invitation_type}. Using it as is.`)
                break
            }
            State.setValue(InvitationState.INVITATION_TYPE, mappedInvitationType)
            State.setValue(InvitationState.INVITATION_USED_EMAIL, email)
            State.setValue(InvitationState.INVITATION_CONTENT, response.data)
            State.setValue(LoginFlowState.LOGIN_FLOW, LoginFlowState.FROM_INVITATION_FLOW)

            const isUserRegistered = await AuthController.isUserRegistered(email)
            console.log('=== isUserRegistered === Invitation.jsx === key: 456839 ===');
            console.dir(isUserRegistered, { depth: null, colors: true })
            console.log('=================================');
            let targetAfterLogin = "/dashboard";
            if (invitation_type === "participant" || typeFromUrl === "participant") {
              targetAfterLogin = `/patient-consent-signature?studyId=${encodeURIComponent(studyIdFromUrl || fetched_study_id || "")}`;
            } else if (
              invitation_type === "investigator" ||
              invitation_type === "cro" ||
              invitation_type === "join_cro" ||
              typeFromUrl === "investigator" ||
              typeFromUrl === "cro" ||
              typeFromUrl === "join_cro"
            ) {
              targetAfterLogin = "/dashboard";
            } else {
              targetAfterLogin = "/dashboard";
            }
             if (isUserRegistered === true) {
               navigate(`/user-signin?redirectTo=${encodeURIComponent(targetAfterLogin)}`);
            } else {
               navigate("/user-signup/");
            }
          } else {
            setErrors(response.message || "Failed to load invitation details.")
            alert(response.message || "Failed to load invitation details.")
          }
        } catch (err) {
          console.error("Error fetching invitation details:", err)
          setInvitationError("An unexpected error occurred while loading invitation details.")
          alert("An unexpected error occurred while loading invitation details.")
        } finally {
          setIsLoadingInvitation(false)
        }
      } else {
        setIsLoadingInvitation(false)
        State.setValue(LoginFlowState.LOGIN_FLOW, LoginFlowState.NORMAL_SIGNUP_FLOW)
      }
    }
    fetchInvitationDetails()
  }, [location.search]);

  return (
   <div>
    {errors || "Wait..."}
   </div>
  );
}
